import React from 'react'

import { Badge } from 'slab'
import { AdminGranularAllowanceConfigStatus } from 'utils/web_api.schemas'

interface StatusBadgeProps {
  status: AdminGranularAllowanceConfigStatus
  isActive: boolean
}

export default function StatusBadge ({ status, isActive }: StatusBadgeProps) {
  const getStatusBadge = () => {
    switch (status) {
      case AdminGranularAllowanceConfigStatus.pending:
        return <Badge type='info'>Pending</Badge>
      case AdminGranularAllowanceConfigStatus.generating:
        return <Badge type='caution'>Generating</Badge>
      case AdminGranularAllowanceConfigStatus.generated:
        return <Badge type='success'>Generated</Badge>
      case AdminGranularAllowanceConfigStatus.failed:
        return <Badge type='critical'>Failed</Badge>
      default:
        return <Badge type='neutral'>{status}</Badge>
    }
  }

  return (
    <div className='flex flex-col gap-1 items-start'>
      {getStatusBadge()}
      {isActive && <Badge type='thatch'>Active</Badge>}
    </div>
  )
}
